module.exports = __webpack_public_path__ + "static/media/encuentro-sitio-aparicion-700.d7e6d5c5.jpg";